import React from 'react';
import { useTranslation } from 'react-i18next';

import SlideDialogV from '../../../components/common/SlideDialogV';

const UnsavedChangesDialog = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation('previousEmployment');

  const buttons = [
    {
      label: t('unsavedChangesDialog.cancelButton'),
      onClick: onClose,
      color: 'primary',
    },
    {
      label: t('unsavedChangesDialog.confirmButton'),
      onClick: onConfirm,
      color: 'secondary',
    },
  ];

  return (
    <SlideDialogV
      isOpen={isOpen}
      onClose={onClose}
      title={t('unsavedChangesDialog.title')} // 변경된 내용이 저장되지 않았습니다
      description={t('unsavedChangesDialog.description')} // 파일을 업로드하셨지만 아직 저장되지 않았습니다. 저장하지 않고 나가시겠습니까?
      buttons={buttons} // 아니오, 계속 작성할래요. 나가기
    />
  );
};

export default UnsavedChangesDialog;
